'use client';

import {useSelector} from 'react-redux';
import {FaShoppingCart} from 'react-icons/fa';
import styles from "./nav-cart.module.css";
import Link from "next/link";
export default function NavCart() {
    const items = useSelector(state => state.cart.items);
    const count = Object.values(items).reduce((sum, it) => sum + it.quantity, 0);
    const label = count > 0 ? `Shopping cart, ${count} item${count === 1 ? "" : "s"}` : "Shopping cart, empty";

    return (
        <Link href="/cart" className={styles.navCartBtn} aria-label={label} title={count > 0 ? label : "Your cart is empty"}>
            {count > 0 && (
                <span className={styles.cartBadgeCounter}>
                    <span>{count}</span>
                </span>
            )}
            <span className={styles.knob} aria-hidden="true">
                <FaShoppingCart />
            </span>
        </Link>
    );
}
